<template>
  <auth-wrapper>
    <form
      class="auth"
      @submit.prevent="signIn"
    >
      <div class="auth-block__data">
        <div
          v-if="isEmailVerified === null && processing && !user"
          class="alert alert-info py-4 d-flex align-items-center justify-content-center"
        >
          <b class="mr-2">Пожалуйста, подождите...</b>
          <b-spinner type="grow" />
        </div>
        <div
          v-else-if="isEmailVerified && user"
          class="alert alert-info pt-4 pb-4 text-center"
        >
          <b>Пользователь: {{ user.email }}</b><br>
          <b>E-mail адрес успешно подтвержден!</b>
        </div>
        <div
          v-else-if="isEmailVerified === false"
          class="alert alert-warning"
        >
          Не удалось подтвердить e-mail. Повторите попытку позже или обратитесь к администратору.
        </div>
        <template v-if="isEmailVerified">
          <div class="input-block">
            <label
              class="input-block__label"
              for="password"
            >
              {{ $t('common.create_password') }}
              <div
                v-if="validation.password.error"
                class="error-text"
              >
                {{ validation.password.error }}
              </div>
            </label>
            <input
              id="password"
              v-model="password"
              class="input-block__input"
              autocomplete="new-password"
              type="password"
              @input="resetErrorMessages"
            >
          </div>
          <label
            class="input-block__label"
            for="password"
          >
            {{ $t('common.confirm_password') }}
            <div
              v-if="validation.confirmPassword.error"
              class="error-text"
            >
              {{ validation.confirmPassword.error }}
            </div>
          </label>
          <input
            id="password"
            v-model="confirmPassword"
            class="input-block__input"
            autocomplete="new-password"
            type="password"
            @input="resetErrorMessages"
          >
        </template>
      </div>
      <div class="actions-block">
        <button
          :disabled="false"
          class="btn spdo-button spdo-button_line spdo-button_filled_white-color"
          type="submit"
        >
          {{ $t('common.set_password') }}
        </button>
      </div>
    </form>
  </auth-wrapper>
</template>

<script>
import { mapState } from 'vuex';
import AuthWrapper from '@/components/auth/AuthWrapper';

export default {
  name: 'EmailVerification',
  components: {
    AuthWrapper,
  },
  props: {
    verificationCode: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isEmailVerified: null,
    processing: false,
    password: '',
    confirmPassword: '',
    validation: {
      password: { error: '', state: null },
      confirmPassword: { error: '', state: null },
    },
  }),
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.$store.commit('signOut', this.$keycloak);
    setTimeout(() => {
      this.verifyEmail();
    }, 100);
  },
  methods: {
    async verifyEmail() {
      this.processing = true;

      try {
        await this.$store.dispatch('getBackendToken', this.verificationCode);

        this.isEmailVerified = true;

        // Get user data if token received
        await this.$store.dispatch('performAuth', {
          jwtacc: localStorage.getItem('jwtacc'),
          refreshToken: localStorage.getItem('refreshToken'),
          locale: this.$i18n.locale,
          app: this,
        });
      } catch (error) {
        this.isEmailVerified = false;
      } finally {
        this.processing = false;
      }
    },
    resetErrorMessages() {
      Object.assign(this.$data.validation, this.$options.data().validation);
    },
    validateForm() {
      this.resetErrorMessages();

      let isFormValid = true;

      if (this.password && this.password.length < 8) {
        this.validation.password.error = 'Длина пароля менее 8 символов';
        this.validation.password.state = false;
        isFormValid = false;
      }

      if (!this.password) {
        this.validation.password.error = 'Необходимо заполнить поле';
        this.validation.password.state = false;
        isFormValid = false;
      }

      if (!this.confirmPassword) {
        this.validation.confirmPassword.error = 'Необходимо заполнить поле';
        this.validation.confirmPassword.state = false;
        isFormValid = false;
      }

      if (this.password !== this.confirmPassword) {
        this.validation.confirmPassword.error = 'Пароль и подтверждение не совпадают';
        this.validation.confirmPassword.state = false;
        isFormValid = false;
      }

      return isFormValid;
    },
    async signIn() {
      if (this.validateForm()) {
        this.processing = true;
        try {
          const params = {
            password: this.password,
          };

          await this.$http.put(`users/${this.user.id}`, params).finally(() => {
            this.loading = false;
          });

          this.$router.push('/desktop');
        } catch (error) {
          if (error.response && error.response.data) {
            this.validation.password.error = error.response.data.message;
          }
        } finally {
          this.processing = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
